// import React, { useEffect, useState } from "react";
// import "../Assests/TaskModal.css";
// import { supabase } from "../Db_Connections/db_connection";
// import { updateTicket } from "../Db_Connections/ticketsApi";
// import { addTicket } from "../Db_Connections/ticketsApi";

// export default function TaskModal({ auth, projects, mode = "create", ticket = null, onClose, onSaved }) {
//     const user = auth || JSON.parse(sessionStorage.getItem("auth"));

//     const [errorMsg, setErrorMsg] = useState("");
//     const [profiles, setProfiles] = useState([]);

//     const [form, setForm] = useState({
//         project_id: "",
//         title: "",
//         type: "Feature",
//         module: "Frontend",
//         assignee_name: "",
//         priority: "Medium",
//         status: "false",
//         story_points: 1,
//         description: "",
//         design_link: "",
//         acceptance_criteria: "",
//         estimated_time: "",
//         file_name: ""
//     }); 
//     // ✅ CHANGE #2: Edit mode -> form prefill
//     useEffect(() => {
//         if (mode === "edit" && ticket) {
//             setForm({
//                 project_id: ticket.project_id ? String(ticket.project_id) : "",
//                 title: ticket.title || "",
//                 type: ticket.type || "Feature",
//                 module: ticket.module || "Frontend",
//                 assignee_name: ticket.assignee || "",        // DB me assignee jo stored hai (email/name)
//                 priority: ticket.priority || "Medium",
//                 status: ticket.status ? "true" : "false",    // boolean -> string
//                 story_points: ticket.story_points ?? 1,
//                 description: ticket.description || "",
//                 design_link: ticket.design_link || "",
//                 acceptance_criteria: ticket.acceptance_criteria || "",
//                 estimated_time: ticket.estimated_time || "",
//                 file_name: ticket.file_name || "",
//             });
//         }
//     }, [mode, ticket]);

//     useEffect(() => {
//         const loadProfiles = async () => {
//             const { data, error } = await supabase
//                 .from("profiles")
//                 .select("first_name,last_name,email")
//                 .order("first_name", { ascending: true });

//             if (error) console.error(error);
//             setProfiles(data || []);
//         };
//         loadProfiles();
//     }, []);

//     const resolveAssigneeEmail = (input) => {
//         console.log("resolve assignee email",input);
        
//         const raw = (input || "").trim();
//         if (!raw) return { email: null, error: "Assignee name is required." };

//         const match = raw.match(/\(([^)]+)\)\s*$/);
//         if (match && match[1]) return { email: match[1].trim(), error: null };

//         const needle = raw.toLowerCase();
//         const found = profiles.filter((p) => {
//             const full = `${p.first_name || ""} ${p.last_name || ""}`
//                 .trim()
//                 .toLowerCase();
//             return full === needle;
//         });

//         if (found.length === 1) return { email: found[0].email, error: null };
//         if (found.length > 1)
//             return { email: null, error: "Multiple users found. Please select suggestion." };

//         return { email: null, error: "User not found. Please select suggestion." };
//     };

//     const submit = async () => {
//         setErrorMsg("");

//         if (!form.project_id) return setErrorMsg("Project is required.");
//         if (!form.title.trim()) return setErrorMsg("Title is required.");
//         if (!form.file_name.trim()) return setErrorMsg("File Name is required.");

//         // const resolved = resolveAssigneeEmail(form.assignee_name);
//         // if (resolved.error) return setErrorMsg(resolved.error);

//         // ✅ ✅ ✅ NEW VALIDATION ADDED HERE
//         const selectedProject = (projects || []).find(
//             (p) => p.id === Number(form.project_id)
//         );

//         if (!selectedProject) {
//             return setErrorMsg("Selected project not found.");
//         }

//         const projectMembers = selectedProject.team_members || [];
//         console.log("project member",projectMembers);
        

//         // Compare by email
//         if (!projectMembers.includes(form.assignee_name)) {
//             return setErrorMsg("This user is not part of the selected project.");
//         }
//         // ✅ ✅ ✅ END VALIDATION

//         const payload = {
//             project_id: Number(form.project_id),
//             title: form.title,
//             type: form.type,
//             module: form.module,
//             assignee: form.assignee_name,
//             reporter: user?.email || "",
//             priority: form.priority,
//             status: form.status === "true",
//             story_points: Number(form.story_points || 1),
//             description: form.description,
//             design_link: form.design_link,
//             acceptance_criteria: form.acceptance_criteria,
//             estimated_time: form.estimated_time,
//             file_name: form.file_name.trim()
//         };

//         // ✅ CHANGE #3: Create vs Edit
//         let res;
//         if (mode === "edit") {
//             // IMPORTANT: ticket_id required for update
//             if (!ticket?.ticket_id) return setErrorMsg("Ticket id missing for edit.");

//             res = await updateTicket(ticket.ticket_id, payload);
//         } else {
//             res = await addTicket(payload);
//         }

//         if (res?.error) return setErrorMsg(res.error.message);
//         onSaved?.();
//     };

//     return (
//         <div className="tm-overlay" onClick={onClose}>
//             <div className="tm-modal" onClick={(e) => e.stopPropagation()}>
//                 <div className="tm-header">
//                     <h3>Assign Task</h3>
//                     <button className="tm-close" onClick={onClose}>×</button>
//                 </div>

//                 <div className="tm-body">
//                     {errorMsg && <div className="tm-error">{errorMsg}</div>}

//                     <div className="tm-group">
//                         <label>Project *</label>
//                         <select
//                             className="tm-input"
//                             value={form.project_id}
//                             onChange={(e) => setForm((p) => ({ ...p, project_id: e.target.value }))}
//                         >
//                             <option value="">Select project</option>
//                             {(projects || []).map((p) => (
//                                 <option key={p.id} value={p.id}>{p.name}</option>
//                             ))}
//                         </select>
//                     </div>

//                     <div className="tm-group">
//                         <label>Title *</label>
//                         <input
//                             className="tm-input"
//                             value={form.title}
//                             onChange={(e) => setForm((p) => ({ ...p, title: e.target.value }))}
//                         />
//                     </div>

//                     <div className="tm-row">
//                         <div className="tm-group">
//                             <label>Type</label>
//                             <select
//                                 className="tm-input"
//                                 value={form.type}
//                                 onChange={(e) => setForm((p) => ({ ...p, type: e.target.value }))}
//                             >
//                                 <option value="Feature">Feature</option>
//                                 <option value="Bug">Bug</option>
//                                 <option value="Improvement">Improvement</option>
//                                 <option value="Tech-debt">Tech-debt</option>
//                                 <option value="Docs">Docs</option>
//                             </select>
//                         </div>

//                         <div className="tm-group">
//                             <label>File Name *</label>
//                             <input
//                                 className="tm-input"
//                                 value={form.file_name}
//                                 onChange={(e) =>
//                                     setForm((p) => ({ ...p, file_name: e.target.value }))
//                                 }
//                             />
//                         </div>

//                         <div className="tm-group">
//                             <label>Module</label>
//                             <select
//                                 className="tm-input"
//                                 value={form.module}
//                                 onChange={(e) => setForm((p) => ({ ...p, module: e.target.value }))}
//                             >
//                                 <option value="Frontend">Frontend</option>
//                                 <option value="Backend">Backend</option>
//                                 <option value="DevOps">DevOps</option>
//                                 <option value="Mobile">Mobile</option>
//                                 <option value="Shared">Shared</option>
//                             </select>
//                         </div>
//                     </div>

//                     <div className="tm-group">
//                         <label>Assignee (Name) *</label>
//                         <input
//                             className="tm-input"
//                             list="assigneeList"
//                             value={form.assignee_name}
//                             onChange={(e) => setForm((p) => ({ ...p, assignee_name: e.target.value }))}
//                             placeholder="Type name (select suggestion)"
//                         />
//                         <datalist id="assigneeList">
//                             {(profiles || []).map((p) => {
//                                 const full = `${p.first_name || ""} ${p.last_name || ""}`.trim();
//                                 return <option key={p.email} value={`${full}`} />;
//                             })}
//                         </datalist>
//                     </div>
//                     <div className="tm-row">
//                         <div className="tm-group">
//                             <label>Priority</label>
//                             <select
//                                 className="tm-input"
//                                 value={form.priority}
//                                 onChange={(e) => setForm((p) => ({ ...p, priority: e.target.value }))}
//                             >
//                                 <option value="High">High</option>
//                                 <option value="Medium">Medium</option>
//                                 <option value="Low">Low</option>
//                             </select>
//                         </div>

//                         <div className="tm-group">
//                             <label>Status (Ready)</label>
//                             <select
//                                 className="tm-input"
//                                 value={form.status}
//                                 onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))}
//                             >
//                                 <option value="false">False</option>
//                                 <option value="true">True</option>
//                             </select>
//                         </div>

//                         <div className="tm-group">
//                             <label>Story Points</label>
//                             <select
//                                 className="tm-input"
//                                 value={form.story_points}
//                                 onChange={(e) => setForm((p) => ({ ...p, story_points: e.target.value }))}
//                             >
//                                 <option value={1}>1</option>
//                                 <option value={2}>2</option>
//                                 <option value={3}>3</option>
//                                 <option value={5}>5</option>
//                                 <option value={8}>8</option>
//                             </select>
//                         </div>
//                     </div>

//                     <div className="tm-group">
//                         <label>Description</label>
//                         <textarea
//                             className="tm-textarea"
//                             value={form.description}
//                             onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))}
//                         />
//                     </div>
                    

//                     <div className="tm-footer">
//                         <button className="tm-btn-secondary" onClick={onClose}>Cancel</button>
//                         <button className="tm-btn-primary" onClick={submit}>Save</button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }
import React, { useEffect, useMemo, useRef, useState } from "react";
import "../Assests/TaskModal.css";
import { supabase } from "../Db_Connections/db_connection";
import { updateTicket, addTicket } from "../Db_Connections/ticketsApi";

export default function TaskModal({
    auth,
    projects,
    mode = "create",
    ticket = null,
    onClose,
    onSaved,
}) {
    const user = auth || JSON.parse(sessionStorage.getItem("auth"));

    const [errorMsg, setErrorMsg] = useState("");
    const [profiles, setProfiles] = useState([]);

    const [form, setForm] = useState({
        project_id: "",
        title: "",
        type: "Feature",
        module: "Frontend",
        assignee_name: "",
        priority: "Medium",
        status: "false",
        story_points: 1,
        description: "",
        design_link: "",
        acceptance_criteria: "",
        estimated_time: "",
        file_name: "",
    });

    // ✅ CHANGE #1: load profiles (same)
    useEffect(() => {
        const loadProfiles = async () => {
            const { data, error } = await supabase
                .from("profiles")
                .select("first_name,last_name,email")
                .order("first_name", { ascending: true });

            if (error) console.error(error);
            setProfiles(data || []);
        };
        loadProfiles();
    }, []);

    // ✅ helper: normalize
    const norm = (s) => String(s || "").trim().toLowerCase();

    // ✅ CHANGE #2: selected project derive
    const selectedProject = useMemo(() => {
        return (projects || []).find((p) => p.id === Number(form.project_id)) || null;
    }, [projects, form.project_id]);

    // ✅ CHANGE #3: safely read team_members (array / json-string / comma string)
    const teamMembersRaw = useMemo(() => {
        let tm = selectedProject?.team_members;

        if (!tm) return [];

        // if stored as JSON string
        if (typeof tm === "string") {
            try {
                const parsed = JSON.parse(tm);
                if (Array.isArray(parsed)) tm = parsed;
                else tm = tm.split(",");
            } catch {
                tm = tm.split(",");
            }
        }

        if (!Array.isArray(tm)) return [];
        return tm.map((x) => String(x).trim()).filter(Boolean);
    }, [selectedProject]);

    // ✅ CHANGE #4: build lookup maps from profiles
    const profileByEmail = useMemo(() => {
        const m = new Map();
        (profiles || []).forEach((p) => m.set(norm(p.email), p));
        return m;
    }, [profiles]);

    const profileByFullName = useMemo(() => {
        const m = new Map();
        (profiles || []).forEach((p) => {
            const full = `${p.first_name || ""} ${p.last_name || ""}`.trim();
            if (full) m.set(norm(full), p);
        });
        return m;
    }, [profiles]);

    // ✅ CHANGE #5: Convert project team member (email OR name) => email
    const memberToEmail = (member) => {
        const raw = String(member || "").trim();
        if (!raw) return null;

        // if already email
        if (raw.includes("@")) return norm(raw);

        // else treat as full name -> find profile -> email
        const p = profileByFullName.get(norm(raw));
        if (p?.email) return norm(p.email);

        return null;
    };

    // ✅ CHANGE #6: allowed emails for selected project
    const allowedEmails = useMemo(() => {
        const set = new Set();
        (teamMembersRaw || []).forEach((m) => {
            const em = memberToEmail(m);
            if (em) set.add(em);
        });
        return set;
    }, [teamMembersRaw, profileByFullName]);

    // ✅ CHANGE #7: filter profiles list -> only project members
    const allowedProfiles = useMemo(() => {
        // If no project selected: show none (so user must select project first)
        if (!selectedProject) return [];
        return (profiles || []).filter((p) => allowedEmails.has(norm(p.email)));
    }, [profiles, allowedEmails, selectedProject]);

    // ✅ helper: email -> "Full Name (email)" (edit prefill)
    const toDisplayAssignee = (assigneeValue) => {
        const raw = (assigneeValue || "").trim();
        if (!raw) return "";

        // already "Name (email)"
        if (raw.includes("(") && raw.includes(")")) return raw;

        // if email, show name if found
        if (raw.includes("@")) {
            const p = profileByEmail.get(norm(raw));
            if (!p) return raw;
            const full = `${p.first_name || ""} ${p.last_name || ""}`.trim();
            return `${full} (${raw})`;
        }

        // old data: plain name
        return raw;
    };

    // ✅ CHANGE #8: Edit mode prefill (same + display helper)
    useEffect(() => {
        if (mode === "edit" && ticket) {
            setForm({
                project_id: ticket.project_id ? String(ticket.project_id) : "",
                title: ticket.title || "",
                type: ticket.type || "Feature",
                module: ticket.module || "Frontend",
                assignee_name: toDisplayAssignee(ticket.assignee || ""),
                priority: ticket.priority || "Medium",
                status: ticket.status ? "true" : "false",
                story_points: ticket.story_points ?? 1,
                description: ticket.description || "",
                design_link: ticket.design_link || "",
                acceptance_criteria: ticket.acceptance_criteria || "",
                estimated_time: ticket.estimated_time || "",
                file_name: ticket.file_name || "",
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode, ticket, profiles]);

    // ✅ CHANGE #9: project change pe old assignee clear (so wrong assignee na rahe)
    const prevProjectIdRef = useRef("");
    useEffect(() => {
        const prev = prevProjectIdRef.current;
        if (prev && prev !== form.project_id) {
            setForm((p) => ({ ...p, assignee_name: "" }));
        }
        prevProjectIdRef.current = form.project_id;
    }, [form.project_id]);

    // ✅ CHANGE #10: resolve "Name (email)" -> email
    const resolveAssigneeEmail = (input) => {
        const raw = (input || "").trim();
        if (!raw) return { email: null, error: "Assignee is required." };

        // direct email typed
        if (raw.includes("@") && !raw.includes("(")) {
            return { email: norm(raw), error: null };
        }

        // "Name (email)"
        const match = raw.match(/\(([^)]+)\)\s*$/);
        if (match && match[1]) return { email: norm(match[1].trim()), error: null };

        // exact full name
        const p = profileByFullName.get(norm(raw));
        if (p?.email) return { email: norm(p.email), error: null };

        return { email: null, error: "User not found. Please select suggestion." };
    };

    const submit = async () => {
        setErrorMsg("");

        if (!form.project_id) return setErrorMsg("Project is required.");
        if (!form.title.trim()) return setErrorMsg("Title is required.");
        if (!form.file_name.trim()) return setErrorMsg("File Name is required.");

        const resolved = resolveAssigneeEmail(form.assignee_name);
        if (resolved.error) return setErrorMsg(resolved.error);

        // ✅ CHANGE #11: Validate ONLY within selected project members
        if (!allowedEmails.has(norm(resolved.email))) {
            return setErrorMsg("This user is not part of the selected project.");
        }

        const payload = {
            project_id: Number(form.project_id),
            title: form.title,
            type: form.type,
            module: form.module,

            // ✅ MAIN FIX: DB me assignee EMAIL save hoga (tabhi assigned user ko dikhega)
            assignee: resolved.email,

            reporter: user?.email || "",
            priority: form.priority,
            status: form.status === "true",
            story_points: Number(form.story_points || 1),
            description: form.description,
            design_link: form.design_link,
            acceptance_criteria: form.acceptance_criteria,
            estimated_time: form.estimated_time,
            file_name: form.file_name.trim(),
        };

        let res;
        if (mode === "edit") {
            if (!ticket?.ticket_id) return setErrorMsg("Ticket id missing for edit.");
            res = await updateTicket(ticket.ticket_id, payload);
        } else {
            res = await addTicket(payload);
        }

        if (res?.error) return setErrorMsg(res.error.message);
        onSaved?.();
    };

    return (
        <div className="tm-overlay" onClick={onClose}>
            <div className="tm-modal" onClick={(e) => e.stopPropagation()}>
                <div className="tm-header">
                    <h3>Assign Task</h3>
                    <button className="tm-close" onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className="tm-body">
                    {errorMsg && <div className="tm-error">{errorMsg}</div>}

                    <div className="tm-group">
                        <label>Project *</label>
                        <select
                            className="tm-input"
                            value={form.project_id}
                            onChange={(e) => setForm((p) => ({ ...p, project_id: e.target.value }))}
                        >
                            <option value="">Select project</option>
                            {(projects || []).map((p) => (
                                <option key={p.id} value={p.id}>
                                    {p.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="tm-group">
                        <label>Title *</label>
                        <input
                            className="tm-input"
                            value={form.title}
                            onChange={(e) => setForm((p) => ({ ...p, title: e.target.value }))}
                        />
                    </div>

                    <div className="tm-row">
                        <div className="tm-group">
                            <label>Type</label>
                            <select
                                className="tm-input"
                                value={form.type}
                                onChange={(e) => setForm((p) => ({ ...p, type: e.target.value }))}
                            >
                                <option value="Feature">Feature</option>
                                <option value="Bug">Bug</option>
                                <option value="Improvement">Improvement</option>
                                <option value="Tech-debt">Tech-debt</option>
                                <option value="Docs">Docs</option>
                            </select>
                        </div>

                        <div className="tm-group">
                            <label>File Name *</label>
                            <input
                                className="tm-input"
                                value={form.file_name}
                                onChange={(e) => setForm((p) => ({ ...p, file_name: e.target.value }))}
                            />
                        </div>

                        <div className="tm-group">
                            <label>Module</label>
                            <select
                                className="tm-input"
                                value={form.module}
                                onChange={(e) => setForm((p) => ({ ...p, module: e.target.value }))}
                            >
                                <option value="Frontend">Frontend</option>
                                <option value="Backend">Backend</option>
                                <option value="DevOps">DevOps</option>
                                <option value="Mobile">Mobile</option>
                                <option value="Shared">Shared</option>
                            </select>
                        </div>
                    </div>

                    <div className="tm-group">
                        <label>Assignee *</label>
                        <input
                            className="tm-input"
                            list="assigneeList"
                            value={form.assignee_name}
                            onChange={(e) =>
                                setForm((p) => ({ ...p, assignee_name: e.target.value }))
                            }
                            // ✅ CHANGE #12: better hint
                            placeholder={selectedProject ? "Select user (project members only)" : "Select project first"}
                            disabled={!selectedProject} // ✅ CHANGE: project select ke bina assignee disable
                        />

                        {/* ✅ CHANGE #13: datalist ONLY project members */}
                        <datalist id="assigneeList">
                            {(allowedProfiles || []).map((p) => {
                                const full = `${p.first_name || ""} ${p.last_name || ""}`.trim();
                                return <option key={p.email} value={`${full} (${p.email})`} />;
                            })}
                        </datalist>
                    </div>

                    <div className="tm-row">
                        <div className="tm-group">
                            <label>Priority</label>
                            <select
                                className="tm-input"
                                value={form.priority}
                                onChange={(e) => setForm((p) => ({ ...p, priority: e.target.value }))}
                            >
                                <option value="High">High</option>
                                <option value="Medium">Medium</option>
                                <option value="Low">Low</option>
                            </select>
                        </div>

                        <div className="tm-group">
                            <label>Status (Ready)</label>
                            <select
                                className="tm-input"
                                value={form.status}
                                onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))}
                            >
                                <option value="false">False</option>
                                <option value="true">True</option>
                            </select>
                        </div>

                        <div className="tm-group">
                            <label>Story Points</label>
                            <select
                                className="tm-input"
                                value={form.story_points}
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, story_points: e.target.value }))
                                }
                            >
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={5}>5</option>
                                <option value={8}>8</option>
                            </select>
                        </div>
                    </div>

                    <div className="tm-group">
                        <label>Description</label>
                        <textarea
                            className="tm-textarea"
                            value={form.description}
                            onChange={(e) =>
                                setForm((p) => ({ ...p, description: e.target.value }))
                            }
                        />
                    </div>

                    <div className="tm-footer">
                        <button className="tm-btn-secondary" onClick={onClose}>
                            Cancel
                        </button>
                        <button className="tm-btn-primary" onClick={submit}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}